import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription, tap } from 'rxjs';
import { AccountManagementService } from '../../services/account-management.service';
import { QuotaPreferenceService } from '../../services/quota-preference.service';
import { QuotaInformation } from '../../../../api/mediaSubscriptions/models/quota-information.api.model';
import { LicensesEnum } from '../../../../api/monitoring/licenses.enum';

/**
 * This component shares state through the {@link QuotaPreferenceService}, as both Monitoring Subscriptions
 * and Social share the same quota data.
 */
@Component({
    selector: 'agpr-quota-preferences',
    templateUrl: './quota-preferences.component.html',
    styleUrls: ['./quota-preferences.component.scss'],
    standalone: false
})
export class QuotaPreferencesComponent implements OnDestroy, OnInit {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    readonly LicensesEnum = LicensesEnum;

    @Input() isSocial: boolean = false;
    @Input()
    set quotaType(type: any) {
        this.quotaPreferenceService.setQuotaType(type);
        this.quota$ = this.quotaPreferenceService.quota$;
    }

    private subscriptions: Subscription[] = [];

    // Subscription values
    hasQuota: boolean = true;
    remainingQuota: number = 0;
    disableInputs: boolean = false;

    // async pipe values
    quota$: Observable<QuotaInformation> = this.quotaPreferenceService.quota$;
    showQuotaBanner$: Observable<boolean> = this.quotaPreferenceService.showQuotaBanner$;

    constructor(
        public accountManagementService: AccountManagementService,
        private quotaPreferenceService: QuotaPreferenceService,
    ) { }

    ngOnInit(): void {
        this.subscriptions.push(
            this.quotaPreferenceService.hasQuota$.subscribe(hasQuota => {
                this.hasQuota = hasQuota;
            }),
            this.quotaPreferenceService.remainingQuota$.subscribe(remainingQuota => {
                this.remainingQuota = remainingQuota;
            }),
            this.quotaPreferenceService.disableInputs$.subscribe(disableInputs => {
                this.disableInputs = disableInputs;
            }),
        );
    }

    calculateRemainingQuota(quota: QuotaInformation) {
        this.quotaPreferenceService.setRemainingQuota(quota);
    }

    ngOnDestroy(): void {
        for (const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }
}
